import { Component, inject, Input, OnInit } from '@angular/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../manager/edro-network-manager';
import { Pool, PoolAdditionalData } from '../../../../../../../apis/pool.api';
import { IProduct } from '../../../../IProduct';
import { P00039DataRxTxIndex } from '../../../P00039Sync';
import {
  IonButton,
  IonContent,
  IonFooter,
  IonHeader,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  IonTitle,
  IonToolbar,
  ModalController,
} from '@ionic/angular/standalone';
import { HeaderConfigurationComponent } from '../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { TranslatePipe } from '@ngx-translate/core';
import { GlobalPageHeaderComponent } from '../../../../../../../components/global-page-header/global-page-header.component';
import { LabelConfigurationComponent } from '../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { SwitchConfigurationComponent } from '../../../../../../../components/ecosystems/switch-configuration/switch-configuration.component';
import { P00032PositionType } from '../../Enum/P00032PositionType';
import { LargedLinkComponent } from '../../../../../../../components/ecosystems/larged-link/larged-link.component';
import { TwoChoicesModalComponent } from '../../../../../../../components/ecosystems/two-choices-modal/two-choices-modal.component';
import { P00032SensContactEnum } from '../../Enum/P00032SensContactEnum';
import { P00032DetectionSensContactModalComponent } from '../../Modal/p00032-detection-sens-contact-modal/p00032-detection-sens-contact-modal.component';
import { LabelDescriptionComponent } from '../../../../../../../components/ecosystems/label-description/label-description.component';
import { InformationTitleComponent } from '../../../../../../../components/ecosystems/information-title/information-title.component';
import { P0003600CourantNominalEnum } from '../../../P0003600/Enum/P0003600CourantNominalEnum';

@Component({
  selector: 'app-p00032-installation-parametrage-capteurs',
  templateUrl: './p00032-installation-parametrage-capteurs.component.html',
  styleUrls: ['./p00032-installation-parametrage-capteurs.component.scss'],
  standalone: true,
  imports: [
    IonFooter,
    IonButton,
    IonContent,
    HeaderConfigurationComponent,
    TranslatePipe,
    IonLabel,
    IonList,
    IonItem,
    IonModal,
    IonHeader,
    IonToolbar,
    IonTitle,
    GlobalPageHeaderComponent,
    LargedLinkComponent,
    SwitchConfigurationComponent,
    LabelDescriptionComponent,
    InformationTitleComponent,
    LabelConfigurationComponent,
  ],
})
export class P00032InstallationParametrageCapteursComponent implements OnInit {
  private modalController: ModalController = inject(ModalController);
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);

  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() pool: Pool | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  positionSondeRx: number | undefined = undefined;
  positionSondePh: number | undefined = undefined;
  positionDebit: number | undefined = undefined;
  positionCapteurTemperature: number | undefined = undefined;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );

    this.positionSondeRx = this.poolAdditionalData?.positionSondeRX ?? 0;
    this.positionSondePh = this.poolAdditionalData?.positionSondePH ?? 0;
    this.positionDebit = this.poolAdditionalData?.positionDetecteurDebit ?? 0;
    this.positionCapteurTemperature =
      this.poolAdditionalData?.positionCapteurTemperature ?? 0;
  }

  onSubmit() {
    this.poolAdditionalData!.positionSondeRX = this.positionSondeRx!;
    this.poolAdditionalData!.positionSondePH = this.positionSondePh!;
    this.poolAdditionalData!.positionDetecteurDebit = this.positionDebit!;
    this.poolAdditionalData!.positionCapteurTemperature =
      this.positionCapteurTemperature!;

    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  async openSensDetectionModal(value: number) {
    if (value !== 99) {
      this.actionStack!.editValue(
        P00039DataRxTxIndex.Sense_Installation,
        'snISensContactSecDebit',
        value,
        null,
      );
      return;
    }

    const modal = await this.modalController.create({
      component: P00032DetectionSensContactModalComponent,
      componentProps: {
        title: 'P00032.installation.inversion.titre',
      },
      cssClass: 'dynamic-height',
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      this.actionStack!.editValue(
        P00039DataRxTxIndex.Sense_Installation,
        'snISensContactSecDebit',
        data.value,
        null,
      );
    }
  }
  async openPositionSondeRxModal() {
    const modal = await this.modalController.create({
      component: TwoChoicesModalComponent,
      componentProps: {
        title: 'P00032.modal.sonderx.title',
        value: this.positionSondeRx,
        firstChoice: {
          title: 'P00032.modal.sonderx.option0',
          image:
            '/assets/ecosystem/images/products/P00032/P00032-sonderx-0.png',
          value: 0,
        },
        secondChoice: {
          title: 'P00032.modal.sonderx.option1',
          image:
            '/assets/ecosystem/images/products/P00032/P00032-sonderx-1.png',
          value: 1,
        },
      },
      cssClass: 'dynamic-height',
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      this.positionSondeRx = data.value;
    }
  }

  async openPositionSondePhModal() {
    const modal = await this.modalController.create({
      component: TwoChoicesModalComponent,
      componentProps: {
        title: 'P00032.modal.sondeph.title',
        value: this.positionSondePh,
        firstChoice: {
          title: 'P00032.modal.sondeph.option0',
          image:
            '/assets/ecosystem/images/products/P00032/P00032-sondeph-0.png',
          value: 0,
        },
        secondChoice: {
          title: 'P00032.modal.sondeph.option1',
          image:
            '/assets/ecosystem/images/products/P00032/P00032-sondeph-1.png',
          value: 1,
        },
      },
      cssClass: 'dynamic-height',
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      this.positionSondePh = data.value;
    }
  }

  async openPositionDebitModal() {
    const modal = await this.modalController.create({
      component: TwoChoicesModalComponent,
      componentProps: {
        title: 'P00032.modal.positiondebit.title',
        value: this.positionDebit,
        firstChoice: {
          title: 'P00032.modal.positiondebit.option0',
          image:
            '/assets/ecosystem/images/products/P00032/P00032-positiondebit-0.png',
          value: 0,
        },
        secondChoice: {
          title: 'P00032.modal.positiondebit.option1',
          image:
            '/assets/ecosystem/images/products/P00032/P00032-positiondebit-1.png',
          value: 1,
        },
      },
      cssClass: 'dynamic-height',
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      this.positionDebit = data.value;
    }
  }

  async openPositionCapteurTemperatureModal() {
    const modal = await this.modalController.create({
      component: TwoChoicesModalComponent,
      componentProps: {
        title: 'P00032.modal.positiontemperature.title',
        value: this.positionCapteurTemperature,
        firstChoice: {
          title: 'P00032.modal.positiontemperature.option0',
          image:
            '/assets/ecosystem/images/products/P00032/P00032-sondetemperature-0.png',
          value: 0,
        },
        secondChoice: {
          title: 'P00032.modal.positiontemperature.option1',
          image:
            '/assets/ecosystem/images/products/P00032/P00032-sondetemperature-1.png',
          value: 1,
        },
      },
      cssClass: 'dynamic-height',
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      this.positionCapteurTemperature = data.value;
    }
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P00032PositionType = P00032PositionType;
  protected readonly P00032SensContactEnum = P00032SensContactEnum;
  protected readonly P0003600CourantNominalEnum = P0003600CourantNominalEnum;
}
